export default {
  importData: 'Importar datos',
  importDataTitle: 'Importar Datos',
  copyInstructions: 'Copia este texto a tu hoja de cálculo, modifícalo y luego cópialo de vuelta:',
  modelDataLabel: 'Datos del Modelo',
  cancel: 'Cancelar',
  import: 'Importar',
  set: 'Establecer',
  period: 'Período',
  onlyDigitsAllowed: 'Solo se permiten dígitos',
  wrongNumberOfRows: 'Número incorrecto de filas',
  wrongNumberOfColumns: 'Número incorrecto de columnas',
  invalidHeaderRow: 'Fila de encabezado inválida',
  invalidPeriodColumn: 'Columna de Período inválida',
  onlyWholeNumbersAllowed: 'Solo se permiten números enteros como valores',
  errorShouldBeDate: 'Error: debe ser una fecha'
}
